import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  caseDetailsCaseId: null,
  clipDetailsClipId: null,
  showAnnotationDialog: false,
  showASIFilterDialog: false,
  showCaseDetailsDialog: false,
  showClipDetailsDialog: false,
  showClipImportWarningDialog: false,
  showCloneDialog: false,
  showCombineClipsDialog: false,
  showDeleteCaseDialog: false,
  showExtractDialog: false,
  showEditorDAWFineTuneDialog: false,
  showFFTSettingsDialog: false,
  showGlimpseModelLengthDialog: false,
  showNLMSFilterDialog: false,
  showSingleChannelActiveDialog: false,
  showSngFilterDialog: false,
  showSngFilterDialogNEW: false,
  showStoiResultsDialog: false,
  showStipaDialog: false,
  showSyncDialog: false,
  showSyncSelectedDialog: false,
  showUntaggedRegionsDialog: false,
};

const dialogSlice = createSlice({
  name: "dialogs",
  initialState,
  reducers: {
    openAnnotationDialog: (state, _action) => {
      state.showAnnotationDialog = true;
    },
    closeAnnotationDialog: (state, _action) => {
      state.showAnnotationDialog = false;
    },
    openASIFilterDialog: (state, _action) => {
      state.showASIFilterDialog = true;
    },
    closeASIFilterDialog: (state, _action) => {
      state.showASIFilterDialog = false;
    },
    openCaseDetailsDialog: (state, action) => {
      state.showCaseDetailsDialog = true;
      state.caseDetailsCaseId = action.payload;
    },
    closeCaseDetailsDialog: (state, _action) => {
      state.showCaseDetailsDialog = false;
      state.caseDetailsCaseId = null;
    },
    openClipDetailsDialog: (state, action) => {
      state.showClipDetailsDialog = true;
      state.clipDetailsClipId = action.payload;
    },
    closeClipDetailsDialog: (state, _action) => {
      state.showClipDetailsDialog = false;
      state.clipDetailsClipId = null;
    },
    openCloneDialog: (state, _action) => {
      state.showCloneDialog = true;
    },
    closeCloneDialog: (state, _action) => {
      state.showCloneDialog = false;
    },
    openClipImportWarningDialog: (state, _action) => {
      state.showClipImportWarningDialog = true;
    },
    closeClipImportWarningDialog: (state, _action) => {
      state.showClipImportWarningDialog = false;
    },
    openCombineClipsDialog: (state, _action) => {
      state.showCombineClipsDialog = true;
    },
    closeCombineClipsDialog: (state, _action) => {
      state.showCombineClipsDialog = false;
    },
    openDeleteCaseDialog: (state, action) => {
      state.showDeleteCaseDialog = true;
      state.caseDetailsCaseId = action.payload;
    },
    closeDeleteCaseDialog: (state, _action) => {
      state.showDeleteCaseDialog = false;
      state.caseDetailsCaseId = null;
    },
    openEditorDAWFineTuneDialog: (state, _action) => {
      state.showEditorDAWFineTuneDialog = true;
    },
    closeEditorDAWFineTuneDialog: (state, _action) => {
      state.showEditorDAWFineTuneDialog = false;
    },
    openExtractDialog: (state, _action) => {
      state.showExtractDialog = true;
    },
    closeExtractDialog: (state, _action) => {
      state.showExtractDialog = false;
    },
    openFFTSettingsDialog: (state, _action) => {
      state.showFFTSettingsDialog = true;
    },
    closeFFTSettingsDialog: (state, _action) => {
      state.showFFTSettingsDialog = false;
    },
    openGlimpseModelLengthDialog: (state, _action) => {
      state.showGlimpseModelLengthDialog = true;
    },
    closeGlimpseModelLengthDialog: (state, _action) => {
      state.showGlimpseModelLengthDialog = false;
    },
    openNLMSFilterDialog: (state, _action) => {
      state.showNLMSFilterDialog = true;
    },
    closeNLMSFilterDialog: (state, _action) => {
      state.showNLMSFilterDialog = false;
    },
    openSingleChannelActiveDialog: (state, _action) => {
      state.showSingleChannelActiveDialog = true;
    },
    closeSingleChannelActiveDialog: (state, _action) => {
      state.showSingleChannelActiveDialog = false;
    },
    openSngFilterDialog: (state, _action) => {
      state.showSngFilterDialog = true;
    },
    closeSngFilterDialog: (state, _action) => {
      state.showSngFilterDialog = false;
    },
    openSngFilterDialogNEW: (state, _action) => {
      state.showSngFilterDialogNEW = true;
    },
    closeSngFilterDialogNEW: (state, _action) => {
      state.showSngFilterDialogNEW = false;
    },
    openStipaDialog: (state, action) => {
      state.showStipaDialog = true;
      state.clipDetailsClipId = action.payload;
    },
    closeStipaDialog: (state, _action) => {
      state.showStipaDialog = false;
      state.clipDetailsClipId = null;
    },
    openStoiResultsDialog: (state, action) => {
      state.showStoiResultsDialog = true;
      state.clipDetailsClipId = action.payload;
    },
    closeStoiResultsDialog: (state, _action) => {
      state.showStoiResultsDialog = false;
      state.clipDetailsClipId = null;
    },
    openSyncDialog: (state, _action) => {
      state.showSyncDialog = true;
    },
    closeSyncDialog: (state, _action) => {
      state.showSyncDialog = false;
    },
    openSyncSelectedDialog: (state, _action) => {
      state.showSyncSelectedDialog = true;
    },
    closeSyncSelectedDialog: (state, _action) => {
      state.showSyncSelectedDialog = false;
    },
    openUntaggedRegionsDialog: (state, _action) => {
      state.showUntaggedRegionsDialog = true;
    },
    closeUntaggedRegionsDialog: (state, _action) => {
      state.showUntaggedRegionsDialog = false;
    },
  },
});

export const {
  openAnnotationDialog,
  closeAnnotationDialog,
  openASIFilterDialog,
  closeASIFilterDialog,
  openCaseDetailsDialog,
  closeCaseDetailsDialog,
  openClipDetailsDialog,
  closeClipDetailsDialog,
  openCloneDialog,
  closeCloneDialog,
  openCombineClipsDialog,
  closeCombineClipsDialog,
  openClipImportWarningDialog,
  closeClipImportWarningDialog,
  openDeleteCaseDialog,
  closeDeleteCaseDialog,
  openEditorDAWFineTuneDialog,
  closeEditorDAWFineTuneDialog,
  openExtractDialog,
  closeExtractDialog,
  openFFTSettingsDialog,
  closeFFTSettingsDialog,
  openGlimpseModelLengthDialog,
  closeGlimpseModelLengthDialog,
  openNLMSFilterDialog,
  closeNLMSFilterDialog,
  openSingleChannelActiveDialog,
  closeSingleChannelActiveDialog,
  openSngFilterDialog,
  closeSngFilterDialog,
  openSngFilterDialogNEW,
  closeSngFilterDialogNEW,
  openStipaDialog,
  closeStipaDialog,
  openStoiResultsDialog,
  closeStoiResultsDialog,
  openSyncDialog,
  closeSyncDialog,
  openSyncSelectedDialog,
  closeSyncSelectedDialog,
  openUntaggedRegionsDialog,
  closeUntaggedRegionsDialog,
} = dialogSlice.actions;

export default dialogSlice.reducer;
